import { render, staticRenderFns } from "./PharmacistCreate.vue?vue&type=template&id=767b77cc&scoped=true&"
import script from "./PharmacistCreate.vue?vue&type=script&lang=ts&"
export * from "./PharmacistCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PharmacistCreate.vue?vue&type=style&index=0&id=767b77cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767b77cc",
  null
  
)

export default component.exports